import { getUniqueSymbols } from '@/entities/symbol/getUniqueSymbols';
import type { MiniTableBodyRow, MiniTableType } from '@/pages/Markets/MarketsComponents/types';
import { getSymbolsFromRows } from '@/pages/Markets/MarketsComponents/utils/getSymbolsFromRows';

function getBodyRows(table: MiniTableType): MiniTableBodyRow[] {
  return table.rows.filter((row): row is MiniTableBodyRow => 'symbol' in row);
}

export function getMiniTableSymbols(table: MiniTableType) {
  return getUniqueSymbols(getSymbolsFromRows(getBodyRows(table)));
}

export function getAllMiniTableSymbols(tables: MiniTableType[]) {
  return tables.flatMap(getMiniTableSymbols);
}
